import {GET_ORDER_TYPES_START, GET_ORDER_TYPES_SUCCESS, GET_ORDER_TYPES_FAILURE, RESET_REDUX, RESET_ON_IMPERSONATION} from "../../actions/actionTypes";

const initialState = {
  orderTypes: [],
  loading: false,
  errors: null,
  dataCollected: false,
};

const orderTypesReducer = (state = initialState, action:any) => {
  switch (action.type) {
    case GET_ORDER_TYPES_START : {
      return {
        ...state,
        loading: true,
      }
    }
    case GET_ORDER_TYPES_SUCCESS : {
      return {
        ...state,
        orderTypes: action.payload,
        loading: false,
        errors: null,
        dataCollected: true,
      }
    }
    case GET_ORDER_TYPES_FAILURE: {
      return {
        ...state,
        errors: action.payload.errors,
        loading: false
      }
    }
    case RESET_ON_IMPERSONATION:
    case RESET_REDUX: {
      return {...initialState}
    }
    default: {
      return state;
    }
  }
};

export default orderTypesReducer;

